// Revisado: 2025-12-18 [I18n Scan]
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const UserSearch = ({ onSearch }) => {
    const { t } = useTranslation();
    const [filters, setFilters] = useState({
        search: '',
        sort_by: 'created_at',
        order: 'desc'
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newFilters = { ...filters, [name]: value };
        setFilters(newFilters);
        onSearch(newFilters);
    };

    return (
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {/* Search Input */}
                <div className="md:col-span-2">
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">{t('UserSearch.label_search')}</label>
                    <div className="relative">
                        <input
                            type="text"
                            name="search"
                            value={filters.search}
                            onChange={handleChange}
                            placeholder={t('UserSearch.placeholder_search')}
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-green focus:border-transparent outline-none"
                        />
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400 absolute left-3 top-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>
                </div>

                {/* Sort By */}
                <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">{t('UserSearch.label_sort_by')}</label>
                    <select
                        name="sort_by"
                        value={filters.sort_by}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-green focus:border-transparent outline-none bg-white"
                    >
                        <option value="created_at">{t('UserSearch.option_created')}</option>
                        <option value="name">{t('UserSearch.option_name')}</option>
                        <option value="last_login">{t('UserSearch.option_last_login')}</option>
                        <option value="role">Rol</option>
                    </select>
                </div>

                {/* Order */}
                <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">{t('UserSearch.label_order')}</label>
                    <select
                        name="order"
                        value={filters.order}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-green focus:border-transparent outline-none bg-white"
                    >
                        <option value="desc">{t('UserSearch.option_desc')}</option>
                        <option value="asc">{t('UserSearch.option_asc')}</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default UserSearch;
